import React from 'react';
import styled from 'styled-components';
import LoadingOverlay from 'react-loading-overlay';
import Header from '../../components/common/header/Header';
import { useDispatch, useSelector } from 'react-redux';
import CustomTitle from '../../components/common/title/CustomTitle';
import Footer from '../../components/common/Footer';
import NormalInput from '../../components/common/input/NormalInput';
import { useState } from 'react';
import NormalBtn from '../../components/common/button/NormalBtn';
import BootPay from "bootpay-js";
import { useEffect } from 'react';
import { setCurMenuAction, setHeaderTransferAction } from '../../modules/common/headerModule';
import { checkAction, changePwAction, resetStatusAction } from '../../modules/su/userCheckModule';
import NormalPopupOneBtn, { NomalPopupOneBtnStyles } from "../../components/common/popup/NormalPopupOneBtn";
import { useHistory, Link, Redirect } from 'react-router-dom';
import Modal from 'react-modal';
import { isMobileOnly } from 'react-device-detect';

const SiResetPasswdBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    padding-top: 80px;
`;

const SiContentsBlock = styled.div`
    padding: 90px 0 120px;
    background-color: #f4f4f4;
`;

const SiContentsBoxBlock = styled.div`
    width: 520px;
    padding: 50px 60px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 6px;
`;

const SiContentsDivBlock = styled.div`
    text-align: center;
`;

const SiContetnsUlBlock = styled.ul`
    display: inline-block;
    margin-left: -50px;
    margin-bottom: 50px;
`;

const SiContentsLiBlock = styled.li`
    float: left;
    padding-left: 50px;
    color: ${prods => prods.color || '#999'};
    font-size: 18px;
    font-weight: 500;
`;

const SiContentsLiGreenBorderBlock = styled.span`
    position: relative;
    z-index: 1;

    ::after {
        bottom: 3px;
        content: "";
        display: block;
        position: absolute;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: #79b88a;
        z-index: -1;
    }
`;

const SiGuideBlock = styled.p`
    ${isMobileOnly?`
    font-size: 14px;
    line-height: 1.43;
    margin-bottom: 16px;
    `:`
    font-size: 16px;
    margin-bottom: 20px;
    `};
    display: block;
    color: #333333;
    font-weight: 400;
    text-align: center;
    
`;

const SiResetPasswdMBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;

    .header-block {
        width: 100vw;
        
        height: 50px;
        background-color: #ffffff;
        position: relative;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #111111;
        line-height: 50px;

        .back {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 7px;
            left: 2px;
            background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
        }
    }

    .top-btn {
        width: 50vw;
        cursor: pointer;
        float:left;
        height: 50px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #cccccc;
        border-bottom: 1px solid #e7e7e7;
    }

    .active {
        cursor: none;
        color: #111111;
        border-bottom: 3px solid #ffc742;
    }

    .contens {
        margin: 0 4vw;
    }
`;

const SiResetPasswdMErrBlock = styled.div`
    display: ${props => props.dispError ? 'block' : 'none'};
    line-height: 16px;
    font-size: 12px;
    color: #fc1c67;
    font-weight: normal;
    line-height: 1.37;
    letter-spacing: -0.7px;
    //margin-bottom: 17px;
    //padding-top: 3px;
    text-align: center;
`;

const SiResetPasswdMErr2Block = styled.div`
    display: ${props => props.dispError ? 'block' : 'none'};
    line-height: 16px;
    font-size: 12px;
    color: #fc1c67;
    font-weight: normal;
    line-height: 1.37;
    letter-spacing: -0.7px;
    //margin-bottom: 17px;
    //padding-top: 3px;
    text-align: center;
    ::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 7px;
        background: url(/assets/images/icon/error-icon.png) center center/cover no-repeat;
        vertical-align: -3px;
    }
`;

const SiResetPasswd = () => {

    const dispatch = useDispatch();

    const [confirm, setConfirm] = useState(false);
    const [confirmReset, setConfirmReset] = useState(null);

    const [email, setEmail] = useState(null);
    const [emailErr, setEmailErr] = useState(false);
    const [emailErrTxt, setEmailErrTxt] = useState("이메일 형식이 맞지 않습니다. 다시 한번 확인해주세요.")

    const [passwd, setPasswd] = useState(null);
    const [passwdConfirm, setPasswdConfirm] = useState(null);
    const [passwdErr, setPasswdErr] = useState(false);
    const [passwdErrTxt, setPasswdErrTxt] = useState("! 6자~20자 이내의 영문+숫자+특수문자의 조합으로 입력해주세요.");
    const [passwdConfirmErr, setPasswdComfirmErr] = useState(false);
    const [passwdConfirmErrTxt, setPasswdConfrimErrTxt] = useState("입력하신 비밀번호가 맞지 않습니다. 다시 확인 해주세요.");

    const [openModal, setOpenModal] = useState(false);
    const [modalMsg, setModalMsg] = useState(null);

    const { checkStatus, loading, message, changeStatus, accessToken } = useSelector(
        ({ userCheckReducer, loadingReducer, userReducer }) => ({
            loading: loadingReducer['user/CHECK'],
            checkStatus: userCheckReducer.checkStatus,
            message: userCheckReducer.message,
            changeStatus: userCheckReducer.changeStatus,
            accessToken: userReducer.accessToken
        })
    );

    const history = useHistory();

    useEffect(() => {

        dispatch(setCurMenuAction('si/resetpw'));
        dispatch(setHeaderTransferAction(false));

        if (checkStatus !== null) {
            if (checkStatus === 200) {
                // console.log("1 message : " + message);
                setConfirm(true);
                setEmailErr(false);
            } else {
                // console.log("2 message : " + message);
                setEmailErr(true);
                setEmailErrTxt(message);
            }
        }

    }, [checkStatus])

    useEffect(() => {

        if (changeStatus !== null) {
            setConfirmReset(true);
            if (checkStatus === 200) {
                setEmailErr(false);
                // 팝업 표시 
                setModalMsg("신규 비밀번호 설정이 완료 되었습니다.")
            } else {
                // console.log("message : " + message);
                setEmailErr(true);
                setEmailErrTxt("비밀번호 변경중 오류가 발생하였습니다. 잠시후 다시 시도해 주세요.");
                // 팝업 표시 
                setModalMsg("비밀번호 변경중 오류가 발생하였습니다. 잠시후 다시 시도해 주세요.")
            }
            setOpenModal(true);
        }

    }, [changeStatus])


    const validateEmail = (value) => {
        if (value === null) return false;
        var regex = /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return (value !== '' && value !== 'undefined' && regex.test(value));
    };

    const validatePassword = (value) => {
        var regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?=+\(\)\.\-&])[A-Za-z\d$@$!%*#?=+\(\)\.\-&]{6,20}$/;
        if (value === null) return false;
        return regex.test(value);
    }

    const handleEmailInput = (e) => {
        // console.log("confirm : " + confirm)
        // console.log("email value : " + e.target.value);
        setEmail(e.target.value);
        setEmailErr(!validateEmail(e.target.value));
    }

    const handlePasswdInput = (e) => {
        // console.log("passwd value : " + e.target.value);
        setPasswd(e.target.value);
        let valid = !validatePassword(e.target.value);
        if (valid) {
            setPasswdErrTxt("! 6자~10자 이내의 영문+숫자+특수문자의 조합으로 입력해주세요.")
        }

        setPasswdErr(valid);
    }

    const handlePasswdConfirmInput = (e) => {
        setPasswdConfirm(e.target.value);
        setPasswdComfirmErr(passwd !== e.target.value);
        if (passwd !== e.target.value) {
            setPasswdConfrimErrTxt("입력하신 비밀번호가 맞지 않습니다. 다시 확인 해주세요.");
        }
    }

    const handleConfirmClick = () => {
        if (confirm === false && emailErr === false && email !== null) {

            let d = new Date();
            // 본인 인증 처리 시작 
            // console.log(" 본인 인증 처리 시작 ---------> ")
            BootPay.request({
                price: 0, // 0으로 해야 한다.
                application_id: process.env.REACT_APP_BOOTPAY_ID,
                name: process.env.REACT_APP_BOOTPAY_NAME, //결제창에서 보여질 이름
                pg: 'danal',
                method: 'auth', // 빌링키를 받기 위한 결제 수단
                show_agree_window: 0, // 부트페이 정보 동의 창 보이기 여부
                order_id: 'ODGAGU' + d.getTime(),
                params: {},
                extra: {
                    age_limit: '14'
                }
            }).error(function (data) {
                // 본인인증 진행시 에러가 발생하면 수행됩니다.
                // console.log(" error : " + JSON.stringify(data));
            }).cancel(function (data) {
                // 본인인증이 취소되면 수행됩니다.
                // console.log("취소 : " + JSON.stringify(data));
            }).done(function (data) {
                // 서버에 data 확인 
                dispatch(checkAction(email, data));
            });
        }
    }

    // 비밀번호 변경 하기 
    const handleChangePw = () => {

        if (!passwdErr && !passwdConfirmErr) {
            // console.log("3 message : " + message);
            dispatch(changePwAction(message, passwd));
        }
    }

    // 팝업 클릭 
    const handlePopupClick = () => {
        dispatch(resetStatusAction());
        setOpenModal(false);
        return history.push('/login');
    }

    const handleBack = () => {
        history.goBack();
    }

    //#2771 탭선택시 초기화
    const handleBtnFindId = () => {
        dispatch(resetStatusAction());
        setOpenModal(false);
        if(isMobileOnly) {
            return history.replace('/findid');
        }
        return history.push('/findid');
    }
    // 로그인 상태이면 
    if (accessToken !== null && accessToken.length > 0) {
        return <Redirect to="/" />
    }

    return (
        isMobileOnly?
        <SiResetPasswdMBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''>
                <div className="header-block">
                    <button className="back" onClick={handleBack} />
                    계정 찾기
                </div>
                <div className="clearfix margin_b-40">
                    <button className="top-btn" onClick={handleBtnFindId}>아이디 찾기</button>
                    <button className="top-btn active">비밀번호 재설정</button>
                </div>
                <div className="contens">
                    <div style={{ display: confirm ? 'none' : 'block'}}>
                            <SiGuideBlock>
                                아이디와 본인인증을 통해 비밀번호를 재설정하세요.
                            </SiGuideBlock>

                            <NormalInput
                                disabled={confirm}
                                type='email'
                                maxLength='100'
                                marginBottom="0px"
                                placeholder='이메일 주소를 입력해주세요.'
                                onChange={handleEmailInput}
                                onFoucs={() => { setEmailErr(!validateEmail(email)); }}
                                onBlur={() => { setEmailErr(!validateEmail(email)); }}
                                dispError={emailErr}
                                errText={emailErrTxt}
                                //errHeight={'100px'}
                                errTop={'10px'}
                                errFontSize={'12px'}
                                spanAlign={'center'}
                                errIcon={true} />

                            <NormalBtn width="100%"
                                disabled={confirm}
                                onClick={handleConfirmClick}
                                lineHeight="52px"
                                bgColor={confirm ? "#d9d9d9" : "#333333"}
                                textColor={confirm ? "#aeaeae" : "#ffffff"}
                                height="52px" borderRadius="4px"
                                fontSize="16px" fontWeight="400"
                                marginBottom="10px" marginTop="40px" float="none"
                                text={confirm ? "본인인증완료" : "본인인증 하기"} />
                    </div>
                    <div style={{ display: confirm ? 'block' : 'none'/* , marginTop: '40px' */ }}>
                            <SiGuideBlock>
                                새 비밀번호로 변경하세요
                            </SiGuideBlock>

                            <NormalInput type='password'
                                maxLength='20'
                                placeholder='새 비밀번호를 입력해주세요.'
                                marginBottom={'10px'}
                                onChange={handlePasswdInput}
                                onFoucs={() => { setPasswdErr(!validatePassword(passwd)); }}
                                onBlur={() => { setPasswdErr(!validatePassword(passwd)); }}
                                //dispError={passwdErr}
                                //errText={passwdErrTxt}
                                spanAlign={'center'}
                                errTop={'10px'}
                                errHeight={'80px'} 
                                errFontSize={'12px'}
                                />
                            <SiResetPasswdMErrBlock className="margin_b-20" dispError={passwdErr}>{passwdErrTxt}</SiResetPasswdMErrBlock>
                            <NormalInput type='password'
                                maxLength='20'
                                placeholder='새 비밀번호를 한번 더 입력해주세요.'
                                marginBottom='0px'
                                marginTop='0px'
                                onFoucs={() => { setPasswdComfirmErr(passwd !== passwdConfirm); }}
                                onBlur={() => { setPasswdComfirmErr(passwd !== passwdConfirm); }}
                                onChange={handlePasswdConfirmInput}
                                //dispError={passwdConfirmErr}
                                //errText={passwdConfirmErrTxt}
                                spanAlign={'center'}
                                errIcon={true}
                                errTop={'10px'}
                                errFontSize={'12px'}
                                //errHeight={'82px'}  
                                />
                            <SiResetPasswdMErr2Block className="margin_t-10" dispError={passwdConfirmErr}>{passwdConfirmErrTxt}</SiResetPasswdMErr2Block>
                            <NormalBtn width="100%"
                                disabled={confirmReset}
                                onClick={handleChangePw}
                                bgColor={confirmReset ? "#d9d9d9" : "#333333"}
                                textColor={confirmReset ? "#aeaeae" : "#ffffff"}
                                lineHeight="52px"
                                height="52px" borderRadius="4px"
                                fontSize="16px" fontWeight="400"
                                marginBottom="10px" marginTop="40px" float="none"
                                text="비밀번호 변경하기" />

                        </div>
                </div>
                
            </LoadingOverlay >

            <Modal
                isOpen={openModal}
                onRequestClose={handlePopupClick}
                style={NomalPopupOneBtnStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopupOneBtn
                    text=""
                    text2={modalMsg} text3=""
                    btn="닫기" onClick={handlePopupClick} />
            </Modal>

        </SiResetPasswdMBlock>
        :
        <SiResetPasswdBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''>

                <Header />
                <SiContentsBlock>
                    <SiContentsBoxBlock>
                        <CustomTitle title="계정 찾기" textColor="#111" />
                        <SiContentsDivBlock>
                            <SiContetnsUlBlock>
                                <SiContentsLiBlock onClick={handleBtnFindId} style={{cursor:'pointer'}}>아이디 찾기</SiContentsLiBlock>
                                <SiContentsLiBlock color='#111'>
                                    <SiContentsLiGreenBorderBlock>
                                        비밀번호 재설정
                                    </SiContentsLiGreenBorderBlock>
                                </SiContentsLiBlock>
                            </SiContetnsUlBlock>
                        </SiContentsDivBlock>
                        <div style={{ display: confirm ? 'none' : 'block'}}>
                            <SiGuideBlock>
                                아이디와 본인인증을 통해 비밀번호를 재설정하세요.
                            </SiGuideBlock>

                            <NormalInput
                                disabled={confirm}
                                type='email'
                                maxLength='100'
                                marginBottom="40px"
                                placeholder='이메일 주소를 입력해주세요.'
                                onChange={handleEmailInput}
                                onFoucs={() => { setEmailErr(!validateEmail(email)); }}
                                onBlur={() => { setEmailErr(!validateEmail(email)); }}
                                dispError={emailErr}
                                errText={emailErrTxt}
                                errHeight={'100px'}
                                errTop={'20px'}
                                spanAlign={'center'}
                                errIcon={true} />

                            <NormalBtn width="100%"
                                disabled={confirm}
                                onClick={handleConfirmClick}
                                lineHeight="58px"
                                bgColor={confirm ? "#d9d9d9" : "#111"}
                                textColor={confirm ? "#aeaeae" : "#fff"}
                                height="60px" borderRadius="30px"
                                fontSize="22px" fontWeight="400"
                                marginBottom="10px" marginTop="0px" float="none"
                                text={confirm ? "본인인증완료" : "본인인증하기"} />
                        </div>
                        <div style={{ display: confirm ? 'block' : 'none'/* , marginTop: '40px' */ }}>
                            <SiGuideBlock>
                                새 비밀번호로 변경하세요
                            </SiGuideBlock>

                            <NormalInput type='password'
                                maxLength='20'
                                placeholder='새 비밀번호를 입력해주세요.'
                                marginBottom='10px'
                                onChange={handlePasswdInput}
                                onFoucs={() => { setPasswdErr(!validatePassword(passwd)); }}
                                onBlur={() => { setPasswdErr(!validatePassword(passwd)); }}
                                dispError={passwdErr}
                                errText={passwdErrTxt}
                                spanAlign={'center'}
                                errHeight={'77px'} />

                            <NormalInput type='password'
                                maxLength='20'
                                placeholder='새 비밀번호를 한번 더 입력해주세요.'
                                marginBottom='30px'
                                onFoucs={() => { setPasswdComfirmErr(passwd !== passwdConfirm); }}
                                onBlur={() => { setPasswdComfirmErr(passwd !== passwdConfirm); }}
                                onChange={handlePasswdConfirmInput}
                                dispError={passwdConfirmErr}
                                errText={passwdConfirmErrTxt}
                                spanAlign={'center'}
                                errIcon={true}
                                errHeight={'82px'}  />

                            <NormalBtn width="100%"
                                disabled={confirmReset}
                                onClick={handleChangePw}
                                bgColor={confirmReset ? "#d9d9d9" : "#111"}
                                textColor={confirmReset ? "#aeaeae" : "#fff"}
                                lineHeight="58px"
                                height="60px" borderRadius="30px"
                                fontSize="22px" fontWeight="400"
                                marginBottom="10px" marginTop="20px" float="none"
                                text="비밀번호 변경하기" />

                        </div>

                    </SiContentsBoxBlock>
                </SiContentsBlock>
                <Footer />
            </LoadingOverlay >

            <Modal
                isOpen={openModal}
                onRequestClose={handlePopupClick}
                style={NomalPopupOneBtnStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopupOneBtn
                    text=""
                    text2={modalMsg} text3=""
                    btn="닫기" onClick={handlePopupClick} />
            </Modal>

        </SiResetPasswdBlock>
    );
};

export default SiResetPasswd;